// extracted by mini-css-extract-plugin
var _1 = "FollowUpsField-moduleFollowUpsField__GK_wV";
var _2 = "FollowUpsField-moduleloadFull__UJKHt";
export { _1 as "FollowUpsField", _2 as "loadFull" }
